import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core/lib/utils';
function commonStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css(["a,a:hover{color:", ";}a[disabled]{color:#e8e8e8;}"], primary6);
}
function commonDropDownStyle(props) {
  return css(["", ""], commonStyle);
}
export default commonDropDownStyle;